module.exports = __webpack_public_path__ + "img/office.8367c04c.png";